import { ArtistPortalAuthUnsupportedError } from './ArtistPortalAuthUnsupportedError';
import { SpotifyAuthRequest, SpotifyAuthResult } from './spotifyAuthTypes';

/**
 * The web app. It cannot do this, and says so.
 *
 * Spotify redirects to `https://artists.spotify.com/?code=…`. A browser page
 * cannot read the url of a cross-origin page it opened, so the code never comes
 * back. The native apps own their browser surface and do it in their own code.
 */
export async function openSpotifyAuth(_request: SpotifyAuthRequest): Promise<SpotifyAuthResult> {
  throw new ArtistPortalAuthUnsupportedError();
}
